import DocumentEditPage, { DocumentEditConfig } from 'src/document-editor/edit/DocumentEditPage';

const config: DocumentEditConfig = {
  pageType: 'meeting-note-edit',
  title: 'Meeting note',
  documentTypePath: 'meeting-notes',
  documentLabel: 'meeting note',
};

export default function MeetingNoteEditPage() {
  return <DocumentEditPage config={config} />;
}
